import { jsxs, jsx } from "react/jsx-runtime";
const IconPromoteSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M15.525 3.15a.998.998 0 0 0-.972-.045L10.763 5H7c-2.757 0-5 2.243-5 5 0 1.283.5 2.476 1.352 3.384l1.527 5.392a2.976 2.976 0 0 0 1.398 1.82 2.984 2.984 0 0 0 2.276.301 2.976 2.976 0 0 0 1.82-1.398c.401-.695.508-1.504.315-2.22L10.213 15h.55l3.79 1.895a1.003 1.003 0 0 0 .972-.044A1 1 0 0 0 16 16V4a1 1 0 0 0-.475-.85ZM7 7h3v6H7a2.94 2.94 0 0 1-1.327-.331 3.083 3.083 0 0 1-.74-.527c-.004-.005-.01-.007-.016-.011A2.949 2.949 0 0 1 4 10c0-1.654 1.346-3 3-3Zm1.742 10.741a.996.996 0 0 1-.101.758.994.994 0 0 1-1.364.365 1.004 1.004 0 0 1-.47-.619l-.96-3.388.015.003c.118.03.237.046.356.066.07.012.14.03.21.039.19.023.38.035.572.035h1.17l.572 2.741ZM14 14.381l-2-1V6.619l2-1v8.764ZM21 9h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2Zm-.974 4.634-1.732-1a1.001 1.001 0 0 0-1 1.732l1.732 1a1.001 1.001 0 0 0 1-1.732ZM17.795 7.5c.17 0 .342-.043.499-.134l1.732-1a1 1 0 1 0-1-1.732l-1.732 1a1 1 0 0 0 .5 1.866Z" })
    ]
  }
);
export {
  IconPromoteSvg
};
